module.exports = __webpack_public_path__ + "static/img/platBanner.e36b54c2.png";